module.exports = "/assets/logo_sg_firefly-fd9d9605a0859fea674f685e1fa07c92.svg";